export const filterIdentifySupplierJobsStyle = (theme) => ({
  paper: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  popoverPaper: {
    width: "300px",
  },
  itemText: {
    marginLeft: "16px",
    marginTop: "10px",
    marginBottom: "10px",
  },
  textDate: {
    width: "144px",
    marginLeft: "2px",
    marginTop: "10px",
    "& input": {
      padding: "10px 10px",
    },
  },
  buttomApplyDate: {
    marginLeft: "2px",
    marginRight: "2px",
    marginTop: "10px",
    marginBottom: "10px",
  },
  buttomFilter: {
    color: "rgba(0, 0, 0, 0.54)",
  },
  rowHeader: {
    marginTop: "10px",
  },
});
